/**
 * OWNED BY C1. D-052: the return leg from Stripe's hosted pages.
 *
 * The Worker sends Checkout back to `/?billing=success`. That flag matters because the session — and so
 * the tier the whole app reads — is cached in KV for 60s, and the Stripe webhook that flipped the account
 * to Pro has no session cookie and therefore cannot invalidate that cache. Without an explicit re-read the
 * user can return from a successful payment to a UI that still says Free.
 *
 * Consumed and stripped from the URL on the way past, like capturePendingInvite(), so a refresh or a
 * back-navigation doesn't replay it.
 */
export type BillingReturn = "success" | "cancelled" | "managed";

export function takeBillingReturn(): BillingReturn | null {
  const value = new URLSearchParams(location.search).get("billing");
  if (value !== "success" && value !== "cancelled" && value !== "managed") return null;

  const url = new URL(location.href);
  url.searchParams.delete("billing");
  history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
  return value;
}
